<template>
  <div id="result-table">
    <div class="mb-2 flex" style="align-items: center;">
      <h3 style="flex: 1">
        <span class="flag-icon" :class="flagClass" style="margin-right: 10px;"></span> {{ typeTitle }}
      </h3>
      <vs-button class="float-right" color="success" icon-pack="feather" icon="icon-plus" @click="addData()">เพิ่มงวด</vs-button>
    </div>
    <vs-table max-items="30" pagination :data="datas" no-data-text="loading...">
      <template slot="thead">
        <vs-th>No.</vs-th>
        <vs-th>วันที่</vs-th>
        <vs-th>รอบ</vs-th>
        <vs-th>เวลาออกผล</vs-th>
        <vs-th>ผล</vs-th>
        <vs-th></vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ index+1 }}
          </vs-td>
          <vs-td>
            {{ tr.lotto_date }}
          </vs-td>
          <vs-td>
            {{ roundName(tr) }}
          </vs-td>
          <vs-td>
            {{ showTime(tr.show_result) }}
          </vs-td>
          <vs-td>
            {{ getResult(tr) }}
          </vs-td>
          <vs-td>
            <vs-button class="float-right ml-2" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteData(tr)">ลบ</vs-button>
            <vs-button class="float-right" color="warning" icon-pack="feather" icon="icon-edit" @click="editData(tr)">แก้ไข</vs-button>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import {lottoConfigs} from "@/configs/lotto.config.js"
import LottoService from "@/services/lottoService"

import moment from "moment"

export default {
  data() {
    return {
      results: []
    }
  },
  computed: {
    datas() {
      return this.results
    },
    lottoType() {
      return this.$route.params.lottoType
    },
    config() {
      let config = lottoConfigs.find((config)=>{
        return config.code === this.$route.params.lottoType
      })

      if(config) {
        return config
      }else{
        return false
      }
    },
    typeTitle() {
      if(this.config) {
        return this.config.name
      }else{
        return this.$route.params.lottoType
      }
    },
    flagClass() {
      if(this.config) {
        return this.config.flag
      }else{
        return null
      }
    }
  },
  watch: {
    lottoType() {
      this.loadResults()
    }
  },
  methods: {
    addData() {
      this.$router.push({ name: 'admin-add-results', params: { lottoType: this.$route.params.lottoType } })
    },
    loadResults() {
      LottoService.getResults(this.$route.params.lottoType).then((response) => {
        this.results = response.datas
      })
    },
    roundName(lotto) {
      let lottoOption = lottoConfigs.find((config)=>{
        return config.code === lotto.lotto_type
      })
      let round = lottoOption.rounds.find((round)=>{
        return round.rcode === lotto.round
      })
      if(round) {
        return round.rname
      }else{
        return '-'
      }
    },
    getResult(lotto) {
      let results = []
      if(lotto.results.prize_1st) {
        results.push(lotto.results.prize_1st)
      }
      if(lotto.results.prize_2nd) {
        results.push(lotto.results.prize_2nd)
      }
      if(results.length > 0) {
        return results.join(', ')
      }else{
        return '-'
      }
    },
    deleteData(lotto) {
      if (confirm('ต้องการลบ?')) {
        LottoService.deleteResult({
          lottoType: lotto.lotto_type,
          lottoId: lotto.lotto_id
        }).then((response) => {
          if (response.status === 'success') {
            this.loadResults()
            this.$vs.notify({
              title: 'สำเร็จ!',
              text: 'ลบข้อมูลเสร็จเรียบร้อย',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            });
          } else {
            this.$vs.notify({
              title: 'ผิดพลาด!',
              text: 'ลบข้อมูลไม่สำเร็จ',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          }
        })
      }
    },
    editData(lotto) {
      this.$router.push({ name: 'admin-edit-results', params: { lottoType: this.$route.params.lottoType, resultId: lotto.lotto_id } })
    },
    showTime(datetime) {
      if (datetime) {
        return moment(datetime).format("YYYY-MM-DD HH:mm")
      } else {
        return '-'
      }
    }
  },
  created() {
    this.loadResults()
  }
}

</script>
<style lang="scss">
#result-table {
  button.vs-button {
    padding: 0.5rem 1rem !important;
  }
}

</style>
